<template>
  <footer :class="{ 'mt-3': marginTopActive, 'mt-lg-5': marginTopActive }" v-if="!$helpers.inIframe()">
    <b-row>
      <b-col class="links-block" :xl="links.thirdColumn ? 3 : 6" md="6" sm="12">
        <div>
          <span  v-for="(link, index) in links.firstColumn" :key="index" v-show="!link.hide">
            <a v-if="isExternalLink(link.href)" target="_blank" :href="link.href">
              {{ link.text}}
            </a>
            <router-link v-else :to="link.href">
              {{ link.text}}
            </router-link>
          </span>
        </div>
      </b-col>
      <b-col class="links-block mt-3 mt-md-0" xl="3" md="6" sm="12">
        <div>
          <span  v-for="(link, index) in links.secondColumn" :key="index" v-show="!link.hide">
            <a v-if="isExternalLink(link.href)" target="_blank" :href="link.href">
              {{ link.text}}
            </a>
            <router-link v-else :to="link.href">
              {{ link.text}}
            </router-link>
          </span>
        </div>
      </b-col>
      <b-col v-if="links.thirdColumn" class="links-block mt-3 mt-md-0" xl="3" md="6" sm="12">
        <div>
          <span  v-for="(link, index) in links.thirdColumn" :key="index">
            <a v-if="isExternalLink(link.href)" target="_blank" :href="link.href">
              {{ link.text}}
            </a>
            <router-link v-else :to="link.href" tag="a">
              {{ link.text }}
            </router-link>
          </span>
        </div>
      </b-col>
      <b-col class="logo logo-footer mt-3 mt-xl-0" xl="3" md="12" sm="12">
        <div>
          <a class="d-block" target="_blank" :href="href"><img :src="logo"></a>
        </div>
      </b-col>
    </b-row>
    <b-row class="cert-icons-footer mt-3">
  <!-- <div v-if="isHealthApp">
    <a href="http://acreditacionseaformec.cgcom.es/solicitud/view_acreditacion?num_expediente=20160919113117" target="_blank">
      <img class="first-icon" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/im_logo_santaria.png">
    </a>
  </div> -->
  <div>
    <img class="middle-icon" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/gdpr.webp"/>
  </div>
  <div>
    <img class="first-icon" src="/static-appopensalud/img/icons/morillas-svg-icons/Logo/hipaa.png"/>
  </div>
  <div v-if="isHealthApp">
    <ISO27001Logo/>
  </div>
  <div>
    <router-link to="/programa-pyme">
      <img class="last-icon" src="/static-appopensalud/img/logos/programapyme.png"/>
    </router-link>
  </div>
</b-row>

    <!-- <div>
        <img width="600px" src="/static-appopensalud/img/logos/pyme-white.png"/>
      </div> -->
    <b-row class="social-icons py-xl-5 mt-3">
      <b-col xl="3" sm="12">
        <a target="_blank" v-for="(link, index) in socialLinks" :href="link.href" :key="index">
          <img :src="link.src" :alt="link.alt"/>
        </a>
        <AddToHomeScreen class="mt-3" white></AddToHomeScreen>
        <!-- <a target="_blank" rel="noopener nofollow" href="https://www.facebook.com/opensalud/"><img alt="opensalud social facebook" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook.svg"></a>                    
        <a target="_blank" rel="noopener nofollow" href="https://www.instagram.com/opensalud/"><img alt="opensalud social instagram" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram.svg"></a>                   
        <a target="_blank" rel="noopener nofollow" href="https://www.linkedin.com/company/10606222?trk=tyah&amp;trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A10606222%2Cidx%3A1-1-1%2CtarId%3A1461928785973%2Ctas%3Aopensalud"><img alt="opensalud social linkedin" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin.svg"></a>                        
        <a target="_blank" rel="noopener nofollow" href="https://www.twitter.com/opensalud"><img alt="opensalud social twitter" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter.svg"></a>    -->
        <!-- <a target="_blank" rel="noopener nofollow" href="https://www.facebook.com/primesaludes/"><img alt="primesaludes social facebook" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook.svg"></a>
        <a target="_blank" rel="noopener nofollow" href="https://www.instagram.com/primesaludes/"><img alt="primesaludes social instagram" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram.svg" class="footer-instagram"></a>
        <a target="_blank" rel="noopener nofollow" href="https://www.linkedin.com/company/primesalud"><img alt="primesalud social linkedin" src="/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin.svg"></a> -->
      </b-col>
      <b-col xl="9" sm="12" class="copyright mt-3 mt-xl-0">
        <div>
          <group-links class="d-block mb-4"></group-links>
          <div class="overline-typescale" :class="{ 'd-block': true, 'text-right': !$uiHelpers.isMobile }">Copyright © {{ new Date().getFullYear() }} {{ companyName }}. {{ $t('all-rights') }}</div>
        </div>
      </b-col>
    </b-row>
  </footer>
</template>

<script>
import routeHelpers from '@/router/routeHelpers'
import GroupLinks from '@/components/base/GroupLinks'
import AddToHomeScreen from '@/components/utils/AddToHomeScreen'
import ISO27001Logo from '@/components/utils/ISO27001Logo'
import { LOGOS_PATH, OPENSALUD_WHITE_LOGO, OPENSALUD_MX_WHITE_LOGO } from '@/constants/logosFileNames'
import { inMx } from '@/helpers/global.helpers'

const messages = {
  es: {
    'all-rights': 'Todos los derechos reservados.'
  },
  en: {
    'all-rights': 'All rights reserved.'
  },
  pt: {
    'all-rights': 'Todos os direitos reservados.'
  }
}

export default {
  name: 'BaseFooter',
  components: {
    GroupLinks,
    AddToHomeScreen,
		ISO27001Logo
  },
  i18n: {
    messages: {
      es: messages.es,
      en: messages.en,
      mx: messages.es
    }
  },
  props: {
    logo: {
      type: String,
      default () {
        return !inMx ? `${LOGOS_PATH}${OPENSALUD_WHITE_LOGO}` : `${LOGOS_PATH}${OPENSALUD_MX_WHITE_LOGO}`
      }
    },
    links: {
      type: Object,
      required: true
    },
    href: {
      type: String,
      required: false
    },
    socialLinks: {
      type: Array,
      required: false,
      default: () => [
        {
          href: 'https://www.facebook.com/opensalud/',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Facebook.svg',
          alt: 'opensalud social facebook'
        },
        {
          href: 'https://www.instagram.com/opensalud/',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Instagram.svg',
          alt: 'opensalud social instagram'
        },
        {
          href: 'https://www.linkedin.com/company/10606222?trk=tyah&amp;trkInfo=clickedVertical%3Acompany%2CclickedEntityId%3A10606222%2Cidx%3A1-1-1%2CtarId%3A1461928785973%2Ctas%3Aopensalud',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Linkedin.svg',
          alt: 'opensalud social linkedin'
        },
        {
          href: 'https://www.twitter.com/opensalud',
          src: '/static-appopensalud/img/icons/morillas-svg-icons/social/ICN_Twitter.svg',
          alt: 'opensalud social twitter'
        }
      ]
    },
    companyName: {
      type: String,
      required: false,
      default: 'Open Healthcare'
    }
  },
  methods: {
     setTarget: function () {
           return '_blank'
      },
      isExternalLink (link) {
        return link && link.indexOf('http') === 0
      }
  },
  computed: {
    isHealthApp () {
      return this.$route.meta.theme !== 'openlegal' && this.companyName !== 'Abogality Pro'
    },
    marginTopActive () {
      return routeHelpers.routeHasReducedLayout(this.$route)
    }
  },
  mounted () {
    this.$nextTick(() => {
      let footer = document.querySelector('footer')
      let content = document.querySelector('.velmld-parent')
      if (!footer || !content) {
        return
      }
      let footerHeight = footer.offsetHeight
      let contentHeight = content.offsetHeight
      if (footerHeight + contentHeight < window.innerHeight) {
        content.style.minHeight = `${window.innerHeight - footerHeight}px`
      }
    })
  }
}
</script>

<style scoped lang="scss">
@import '../../../static-appopensalud/css/scss/ui.scss';

footer {
	a {
		@include overline-typescale;
	}

  .stick-bottom {
    position: absolute;
    bottom: 0;
    width: 100vw;
  }
  text-align: left;
  text-transform: uppercase;
  @include container-padding;
  padding-top: 6rem;
	@include mobile {
		padding-top: 3rem;
	}
  padding-bottom: 6rem;
  background-color: $black;
  color: $white;

  .logo {
    div {
      @include desktop {
        float: right;
      }
      @include media(mobile, tablets) {
        float: none;
      }
    }

    img {
      width: 200px;

			@include media(tablets, mobile) {
				width: 135px;
			}
    }

  }

  .links-block div {
    border-top: 1px solid;
    padding-top: 2rem;
    display: inline-block;

    a {
      padding-bottom: 1rem;
      color: $white;
      display: block;
      transition-duration: .5s;

      &:hover {
        text-decoration: none;
        margin-left: 0.5rem;
        transition-duration: .5s;
      }
    }
  }

  .social-icons a {
    margin-right: 2rem;
    display: inline-flex;

    img {
      transform: scale(1);
      transition-duration: .5s;
			max-width: 1.75rem;
    }


    &:hover {
      img {
        transform: scale(1.2);
        transition-duration: .5s;
      }
    }
  }

  .copyright > div {
    @include desktop {
      float: right;
    }
    @include media(tablets, mobile) {
      float: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseFooter.vue